/**
 * Shared site configuration.
 * Centralises hardcoded hosts/URLs so they are defined in a single place.
 */

/** Canonical production hostname for the storefront. */
export const PRODUCTION_HOST = 'shop.deliciousexpress.com.hk';

/** Full production site URL (origin). */
export const SITE_URL = `https://${PRODUCTION_HOST}`;

/** Cloudflare Worker (backend API) origin. */
export const WORKER_URL = 'https://gs2.jimsbond007.workers.dev';
